export const SET_TOKEN = "SET_TOKEN";
export const AUTH_LOADING = "AUTH_LOADING";
export const SET_USER = "SET_USER";
export const SET_NOTES = "SET_NOTES";
export const TOGGLE_COLOR_PALLETE = "TOGGLE_COLOR_PALLETE";
export const SET_TRASH = "SET_TRASH";
export const SET_ARCHIVE = "SET_ARCHIVE";
export const optionColor = [
  {
    id: 111,
    color: "#16504b",
  },
  {
    id: 2222,
    color: "#2d555e",
  },
  {
    id: 444,
    color: "#ffffbe",
  },
  {
    id: 54,
    color: "#fed4da",
  },
  {
    id: 64,
    color: "#b0e0e6",
  },
];
